<template src="../templates/newsGrid.html"></template>

<script>

import {
    getNewsForEdit,
    updateNews,
    removeNews
} from '@api/questionnaire-news';
import extractEnvironmentValuesMixin from '@/mixins/extractEnvironmentValuesMixin';
import Datepicker from 'vue3-datepicker';
import Editor from '@tinymce/tinymce-vue';
import Grid from '@c/Grid';
import Modal from '@c/Modal';
import Button from '@f/Button';
import FormCheckbox from '@f/Check';
import FormTextarea from '@f/Textarea';
// eslint-disable-next-line import/no-extraneous-dependencies
import {ru} from 'date-fns/locale';
import Error from '@c/Error';

export default {
    name: 'NewsGrid',
    components: {
        Datepicker,
        Grid,
        Modal,
        Button,
        FormTextarea,
        FormCheckbox,
        Editor,
        Error,
    },
    mixins: [
        extractEnvironmentValuesMixin,
    ],
    props: {
        id: {
            type: String,
            default() {
                return null;
            },
        },
    },
    data() {
        return {
            news: {},
            pageNumber: 0,
            showModal: false,
            sendProcess: false,
            editNewsData: {},
            dpSettings: {
                locale: ru
            },
            errors: {
                news: [],
                dueDateTo: [],
            },
        };
    },
    computed: {
        isValid() {
            return Object.values(this.errors).filter(field => field.length > 0).length === 0;
        },
    },
    watch: {
        editNewsData: {
            handler() {
                this.validate();
            },
            deep: true
        }
    },
    created() {
        this.updateNews(this.id);
        this.validate();
    },
    methods: {
        edit(id) {
            if (typeof this.news[id] !== 'undefined') {
                this.editNewsData = {...this.news[id]};
            } else {
                this.editNewsData = {
                    questionnaire_id: this.id
                };
            }
            this.showModal = true;
            this.validate();
        },

        async remove(id) {
            // eslint-disable-next-line no-alert
            if (window.confirm('Удалить новость?')) {
                if (await removeNews(id)) {
                    await this.updateNews(this.id);
                } else {
                    console.log('Error 4738: Новость не удалена');
                }
            }
        },

        async save() {
            this.sendProcess = true;
            const newsData = {
                ...this.editNewsData,
                due_date_to: new Date(Date.UTC(
                    this.editNewsData.due_date_to.getFullYear(),
                    this.editNewsData.due_date_to.getMonth(),
                    this.editNewsData.due_date_to.getDate()
                ))
            };
            delete newsData.create_date;
            if (await updateNews(this.editNewsData.id, newsData)) {
                this.sendProcess = false;
                this.showModal = false;
                await this.updateNews(this.id);
            } else {
                console.log('Error 7439: Новость не сохранена');
            }
        },

        async updateNews(questionnaireId) {

            this.news = {};

            /**
             * @type {array}
             */
            const newsAll = await getNewsForEdit(questionnaireId);
            newsAll.forEach((news) => {
                this.news[news.id] = news;
                if (news.create_date) this.news[news.id].create_date = new Date(news.create_date);
                if (news.due_date_to) this.news[news.id].due_date_to = new Date(news.due_date_to);
            });
        },

        validate() {
            Object.keys(this.errors).forEach(field => {
                this.errors[field] = [];
            });
            if (!this.editNewsData.news) {
                this.errors.news.push('Не заполнен текст новости!');
            }
            if (!this.editNewsData.due_date_to) {
                this.errors.dueDateTo.push('Обязательно заполните дату действия новости!');
            } else if (this.editNewsData.due_date_to < new Date()) {
                this.errors.dueDateTo.push('Дата действия новости должна быть больше текущей даты!');
            }
        },
    }
};

</script>
